import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-arrow-right-green.png'


const _withScopeId = n => (_pushScopeId("data-v-8ac4ecb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "charity-list"
}
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "strong" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-right"
}, null, -1))
const _hoisted_7 = { class: "dialog-wrapper" }
const _hoisted_8 = {
  class: "d-flex justify-content-center align-items-center",
  style: {"margin":"1.25rem 0 1rem"}
}
const _hoisted_9 = { class: "promary" }
const _hoisted_10 = { class: "text-content" }
const _hoisted_11 = { class: "label" }

import { reactive, ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { ICharity, getCharityDefaultData } from '@/types/charity';
  import IconCollectionDefault from '@/assets/icon/icon-collection-default.png';
  import IconCollectionActive from '@/assets/icon/icon-collection-active.png';
  import { request, alert } from '@/utils';
  import { useToast } from 'bootstrap-vue-3';

  interface IProps {
    list: ICharity[];
    points: number | undefined;
    pointUsage: boolean | undefined;
    minDonatePoints: number | undefined;
  }

  interface IEmits {
    (event: 'updateFavored', data: ICharity): void;
    (event: 'submited'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    list: null,
    points: null,
    pointUsage: { type: [Boolean, null] },
    minDonatePoints: null
  },
  emits: ["updateFavored", "submited"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'updateFavored', data: ICharity): void;
    (event: 'submited'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    list: ICharity[];
    points: number | undefined;
    pointUsage: boolean | undefined;
    minDonatePoints: number | undefined;
  }

  
  
  const { t } = useI18n();
  const dialogContent = reactive({
    show: false
  });
  const toast = useToast();
  const currentCharity = reactive(getCharityDefaultData());
  const donateValue = ref('');

  const placeholderText = computed(() => {
    return `Minimum of ${props.minDonatePoints || 0} points`;
  });

  function handleShowPopup(item: ICharity) {
    Object.assign(currentCharity, item);
    dialogContent.show = true;
  }

  async function handleTriggerCollection(item: ICharity) {
    const params = { action_type: 'favor', target_type: 'Charity', target_id: item.id };
    if (item.favored) {
      await request.delete('/action_stores', { params });
    } else {
      await request.post('/action_stores', params);
    }
    const newItem = { ...item };
    newItem.favored = !item.favored;
    emits('updateFavored', newItem);
  }

  async function handleSubmit() {
    const points = Number(donateValue.value);
    if (props.minDonatePoints && props.minDonatePoints > points) {
      toast.show({ title: t('Tips'), body: placeholderText }, { variant: 'warning' });
      return;
    }
    if (Number(props.points) < points) {
      toast.show({ title: t('Tips'), body: t('Not enough points') }, { variant: 'warning' });
      return;
    }
    await request.post('donate_records', { charity_id: currentCharity.id, points });
    dialogContent.show = false;
    alert({ title: t('Success'), content: t('review'), });
    emits('submited');
  }

return (_ctx: any,_cache: any) => {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.list.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "result-item"
            }, [
              _createElementVNode("div", null, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: item.favored ? _unref(IconCollectionActive) : _unref(IconCollectionDefault),
                  class: "icon-collection",
                  onClick: ($event: any) => (handleTriggerCollection(item))
                }, null, 8, _hoisted_3),
                (__props.pointUsage)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "d-flex align-items-center pointer",
                      onClick: ($event: any) => (handleShowPopup(item))
                    }, [
                      _createElementVNode("strong", _hoisted_5, _toDisplayString(_unref(t)('Redeem')), 1),
                      _hoisted_6
                    ], 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialogContent).show,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialogContent).show) = $event)),
      title: _unref(t)('Current Points Balance'),
      "btn-text": _unref(t)('Redeem points'),
      onConfirm: handleSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(__props.points), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('points')), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(currentCharity).name), 1),
            _createVNode(_component_b_form_input, {
              modelValue: donateValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((donateValue).value = $event)),
              placeholder: _unref(placeholderText)
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "btn-text"])
  ], 64))
}
}

})